import { useState } from 'react';
import { useIntl } from 'react-intl';

import {
  approveFound,
  markAsConfirmedLostFromUnknown
} from 'services/ops-control';

import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

export const PendingOnUnknownActions = ({ delivery }) => {
  const intl = useIntl();
  const [foundLoading, setFoundLoading] = useState(false);
  const [notFoundLoading, setNotFoundLoading] = useState(false);

  const handleFoundIt = async () => {
    try {
      setFoundLoading(true);
      const res = await approveFound(delivery?._id);
      notify(res.message, 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      setFoundLoading(false);
    }
  };

  const handleNotFound = async () => {
    try {
      setNotFoundLoading(true);
      const res = await markAsConfirmedLostFromUnknown(delivery?._id, {
        deliveryId: delivery?._id
      });
      notify(res.message, 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      setNotFoundLoading(false);
    }
  };

  return (
    <div className="br-lost-orders__action-buttons-wrapper">
      <BRButton
        type={'outline'}
        className={'br-lost-orders__hub-liable'}
        label={intl.formatMessage({
          id: 'ops_control.lost_orders.table_columns.found_it'
        })}
        onClick={handleFoundIt}
        loading={foundLoading}
      />
      <BRButton
        className={'br-lost-orders__star-liable'}
        type={'basic'}
        label={intl.formatMessage({
          id: 'ops_control.lost_orders.table_actions.not_found'
        })}
        onClick={handleNotFound}
        loading={notFoundLoading}
      />
    </div>
  );
};
